export const all_routes = {
  dashboard: "/",
  productlist: "/products",
  addproduct: "/add-product",
  brandlist: "/brands",
  units: "/units",
  categorylist: "/categories",
  editproduct: "/edit-product/:id",
  serialtrack: "/serial-track",
  purchaselist: "/purchases",
  pos: "/pos",
  saleslist: "/sales",
  customers: "/customers",
  suppliers: "/suppliers",
  inventoryList: "/inventory-list",
  inventoryTransactions: "/inventory-transactions",
  stockadjustment: "/stock-adjustments",
  stocktransfer: "/stock-transfers",
  newTransfer: "/new-transfer",
  editTransfer: "/edit-transfer/:id",
  onboarding: "/onboarding",
  signin: "/signin",
  forgotPassword: "/forgot-password",
  register: "/register",
  error404: "/error-404",
  error500: "/error-500",
  users: "/employees",
  storeList: "/stores",
  administration: "/admins",
  editAdmin: "/edit-admin/:id",
  addAdmin: "/add-admin",
  newStore: "/new-store",
  editStore: "/edit-store/:id",
  addEmployee: "/add-employee",
  editEmployee: "/edit-employee/:id",
  addSupplier: "/add-supplier",
  editSupplier: "/edit-supplier/:id",
  editCategory: "/edit-category/:id",
  addCategory: "/add-category",
  designations: "/designations",
  roles: "/roles",
  customerGroups: "/customer-groups",
  newPurchase: "/new-purchase",
  editPurchase: "/edit-purchase/:id",
  grn: "/grn",
  addGrn: "/add-grn",
  editGrn: "/edit-grn/:id",
  repairs: "/pos/repairs/:id",
  repairPos: "/pos/repair",
  brandModels: "/brand-models",
  repairDashboard: "/repair-dashboard",
  repairCategories: "/repair-categories",
  addRepair: "/add-repair",
  editRepair: "/edit-repair/:id",
  predefinedRepairs: "/predefined-repairs",
  addPredefinedRepair: "/add-predefined-repair",
  editPredefinedRepair: "/edit-predefined-repair/:id",
  tenantSettings: "/tenant-settings",
  tasks: "/tasks",
  specialParts: "/special-parts",
  media: "/media-library",
  payments: "/payments",
  cartHistory: "/cart-history",
  newSale: "/new-sale",
  openingStock: "/opening-stock",
  pendingApprovals: "/pending-approvals",
  expenses: "/expenses",
  expensecategory: "/expense-categories",
  stockReports: "/stock-reports",
  expenseReports: "/expense-reports",
  salesSummaryReport: "/sales-summary-report",
  customerwiseSalesReport: "/customerwise-sales-report",
  partsUsageReport: "/parts-usage-report",
  serialBarcodeReport: "/serial-barcode-report",
  dailyCashBalanceReport: "/daily-cash-balance-report",
  quotationsList: "/quotations",
  newQuotation: "/new-quotation",
  editQuotation: "/edit-quotation/:id",
  convertToSale: "/convert-to-sale/:id",
  supplierwiseExpenseReport: "/supplierwise-expense-report",
  inventoryMovementReport: "/inventory-movement-report",
  profitLossReport: "/profit-loss-report",
  stockTransferReport: "/stock-transfer-report",
  salesInvoiceReport: "/sales-invoice-report",
  assembleConfigs: "/assemble-configs",
  addAssembleConfig: "/add-assemble-config",
  editAssembleConfig: "/edit-assemble-config/:id",
  assembleJobs: "/assemble-jobs",
  addAssembleJob: "/add-assemble-job",
  editAssembleJob: "/edit-assemble-job/:id",
  convertAssembleJobToSale: "/convert-assemble-job-to-sale/:id",
  convertAssembleJobToQuotation: "/convert-assemble-job-to-quotation/:id",
  recurringInvoices: "/recurring-invoices",
  newRecurringInvoice: "/new-recurring-invoice",
  editRecurringInvoice: "/edit-recurring-invoice/:id",
  warrantyClaims: "/warranty-claims",
  addWarrantyClaim: "/add-warranty-claim",
  warrantyClaimDetail: "/warranty-claims/:id",
  paymentMethods: "/payment-methods",
  printers: "/printers",
  templates: "/templates",
  addTemplate: "/add-template",
  editTemplate: "/edit-template/:id",
};
